import { getService as service } from '../util/angular_helpers.js';
import { fetchRecommendedFonts } from '../util/recommendations.js';
import { addPageAction } from '../util/new_relic.js';
import { loadCustomCarousel } from '../util/custom_carousel_helper.js';

// Breakpoint constants for responsive sizing
const EXTRA_LARGE_BREAKPOINT = 1200;
const LARGE_BREAKPOINT = 768;

function updateHeroSearchbarSize() {
  const searchBar = document.getElementById('hero-searchbar');
  if (!searchBar) {
    return;
  }

  const width = window.innerWidth;
  let size = 'm'; // default medium

  // The width values used below need to be coordinated with the SCSS values in _home_crossbar.scss
  if (width >= EXTRA_LARGE_BREAKPOINT) { // extra large
    size = 'xl';
  } else if (width >= LARGE_BREAKPOINT) { // large
    size = 'l';
  }

  searchBar.setAttribute('size', size);
}

function init() {
  loadCustomCarousel();
  loadHiddenGems();
  loadNewestFonts();
  loadTrendingFonts();

  // Initialize search bar responsive sizing
  document.addEventListener('DOMContentLoaded', () => {
    updateHeroSearchbarSize();
    window.addEventListener('resize', updateHeroSearchbarSize);
  });

  // The analytics service relies on the legacy Angular app, so we need to wait
  // until that's loaded before we can initialize it.
  window.addEventListener('DOMContentLoaded', () => {
    initAnalyticsEvents();
  });
}

function initAnalyticsEvents() {
  // Initialize notification click tracker
  const NewrelicClickTrackerService = service('NewrelicClickTrackerService');
  NewrelicClickTrackerService.init({page: 'crossbar_homepage'});

  // Unload event
  window.addEventListener('beforeunload', function() {
    addPageAction('typekit.crossbar_homepage.page_exit');
  });
}

function loadHiddenGems() {
  fetchRecommendedFonts({
    familiesPerPage: 16,
    isPersonalized: false,
    page: 1,

    type: 'hidden_gems'
  }).then(items => {
    setElementItems(
      document.querySelector('#home-hidden-gems-fonts'), items);
  });
}

function loadNewestFonts() {
  fetchRecommendedFonts({
    familiesPerPage: 16,
    isPersonalized: false,
    page: 1,
    type: 'newest'
  }).then(items => {
    setElementItems(
      document.querySelector('#home-newest-fonts'), items);
  });
}

function loadTrendingFonts() {
  fetchRecommendedFonts({
    familiesPerPage: 16,
    isPersonalized: false,

    page: 1,
    type: 'trending'
  }).then(items => {
    setElementItems(
      document.querySelector('#home-trending-fonts'), items);
  });
}

function setElementItems(element, items) {
  if (!element) {
    return;
  }

  element.items = items;
}

export { init };
